define( function() {
	"use strict";

	return { guid: Date.now() };
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/nonce.js
// module id = 145
// module chunks = 0